const detailsDialog4i = function(){
	const common = new CartCommon();
	const messages = common.Messages;
	const detailsDialog = new Dialog4i();
	const loadingContent = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading item details dialog, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';

	const init = () =>{
		detailsDialog.Init({
			triggerElements: [].slice.call(document.querySelectorAll('.cartDetailsBtn')),
			dialogClass: "divItemDetails",
			title: "Loading Item Details", 
			content: loadingContent, 
			onOpen: open
		});
	};
	
	const open = async (el) => {
		const itemID = el.getAttribute("data-cart-item-id");
		let responseHTML;
		try{
			const response = await fetch('/cart/itemdetails', { 
				method: 'POST', 
				body: JSON.stringify({ cartId: common.CartID, cartItemId: itemID }), 
				headers: { 
					'Content-Type': 'application/json', 
					'X-Requested-With': 'fetch', 
					"__RequestVerificationToken": common.Token 
				}
			});
			
			if(!response.ok) throw new Error("Error processing item details request");
			responseHTML = await response.text();
		}catch(error){
			console.error(error);
			detailsDialog.Close();
			common.ShowMessage(messages.getItemDetailsError);
		}
		if(responseHTML) showItemDetails(el, responseHTML);
	};
	
	const showItemDetails = (el, html) =>{
		const prodName = el.parentNode.parentNode.querySelector(".productInfo").textContent;
		const dialogHead = document.getElementById("popUpDialog").querySelector("h2");
		const dialogContent = document.getElementById("popUpDialog").querySelector(".dialogContent");
		dialogHead.textContent = prodName;
		dialogContent.innerHTML = html;
		common.HideMessage();
	};
	
	return{
		Init: init
	};
};